// removed by extract-text-webpack-plugin
module.exports = {"binary_button_close":"_1Vuy5uIuemOUXkFI8QGjDG","binary_button_close_border":"_3P6KAzjkkX2LJZMcECs7YJ"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCloseButton/BinaryCloseButton.scss
// module id = 2138
// module chunks = 1